module.exports = __webpack_public_path__ + "img/naar-en-ven-1.c46ae8c6.png";